var $navMovingBar = document.querySelector('nav'),
    $btnMenu11 = $navMovingBar.querySelectorAll('.nav-primary'),
    bar = document.createElement('span'),
    width, left, initWidth, initLeft;

var activeIdx = null;
var activeWidth = 0;
var activeLeft = 0;

// desktop nav link animations
function MovingBar(nav){

   for( var i=0, max=$btnMenu11.length; i<max; i++ ){
       if ($btnMenu11[i].classList.contains("on")){
        activeIdx = i;
        activeWidth = $btnMenu11[i].offsetWidth;
        activeLeft = $btnMenu11[i].offsetLeft;
       }



   }
   if(activeIdx !== null) {
    // console.log('you are on one of the main nav pages');
   } else {
    // console.log('you are home or on an orphan or product page');
   }



    bar.classList.add('effect');

    $navMovingBar.appendChild( bar );

    for( var i=0, max=$btnMenu11.length; i<max; i++ ){

        $btnMenu11[i].addEventListener('mouseenter', function(){
            width = this.offsetWidth,
            left = this.offsetLeft;
            barMovingCurrentMenu( width, left );
        });

        $btnMenu11[i].addEventListener('mouseleave', function(){

           width = activeWidth;
           left = activeLeft;

           barMovingCurrentMenu( width, left );
        });
    }


}

function barMovingCurrentMenu( width, left ) {
    bar.style.width = width + 'px';
    bar.style.left = left + 'px';
}

window.addEventListener('load', function(){

});



    // shrink nav on scroll down
    var scrollPos = 0;
    var positionTimer;
    $(window).scroll(function () {
        var curScrollPos = $(this).scrollTop();
        var headerHeight = $('header').height();

        // whenever a scroll event is fired, we want to clear any setTimeOut, which might've been executed(planned) when the prvious scroll event fired
        // in other words, it's like saying: cancel all my plans, I need to rethink this and set new plans, if needed.
        clearTimeout(positionTimer);

        if (curScrollPos > 0) {
            $('header').css('position', 'fixed');
        } else {
            positionTimer = setTimeout(function(){
                $('header').css('position', 'relative');
            }, 0);
            // the delay is 0, but it doesn't mean immediately, it means as soon as possible.
            // it should never be needed, but just in case, we do it this way to bulletproof it.
        }

        if (curScrollPos > scrollPos && curScrollPos > 30) {
            $('header').addClass('shrink-nav');
            if (activeIdx !== null) {
            activeWidth = $btnMenu11[activeIdx].offsetWidth;
            activeLeft = $btnMenu11[activeIdx].offsetLeft;
            barMovingCurrentMenu(activeWidth, activeLeft);
            }
        } else {
            $('header').removeClass('shrink-nav');
            if (activeIdx !== null) {
                activeWidth = $btnMenu11[activeIdx].offsetWidth;
                activeLeft = $btnMenu11[activeIdx].offsetLeft;
                barMovingCurrentMenu(activeWidth, activeLeft);
            }
        }
        scrollPos = curScrollPos;

    });
    var breaks = [1440, 1200, 992];
    $(window).on('resize', function () {
        //console.log(this.innerWidth);
        //active nav state must be detected to correctly reposition active span
        //a range is given because value does not increment by unit but occasionally
        //jumps values
        if (this.innerWidth >= 1436 && this.innerWidth <= 1444 ||
            this.innerWidth >= 1188 && this.innerWidth <= 1204 ||
            this.innerWidth >= 988 && this.innerWidth <= 996) {
            if ((isheader) && (activeIdx !== null)) {
                console.log('this isHeader is YES & we are ')
                setTimeout(function () {
                    activeWidth = $btnMenu11[activeIdx].offsetWidth;
                    activeLeft = $btnMenu11[activeIdx].offsetLeft;
                    barMovingCurrentMenu(activeWidth, activeLeft);
                }, 125);
            }
        }
    })


$(document).ready(function() {

    // mobile menu
    var childElements = $('section, footer').find('*').toArray();
    const iframeElement = $('iframe');

    $('.menu-toggle').click(function() {
        const menuContainer = document.getElementById('navigation-container');
        $(this).toggleClass('open');
        trackGTM('topnav_hamburger');
        $('#mainMenu').toggleClass('open').slideToggle();
        if ($(this).hasClass("open")) {
            menuContainer.setAttribute('role', 'dialog');
            menuContainer.setAttribute('aria-label', 'main navigation');

            $(this).attr('aria-expanded', 'true');
            $(this).attr('aria-label', 'close menu');
            $('.mobilemenuhidden').attr('aria-hidden', 'true');
            $('section').attr('aria-hidden', 'true');
            $('.triangle-inverted').attr('aria-hidden', 'true');
            $('#sitesearchform').attr('aria-hidden', 'true');
            $(childElements).css('visibility', 'hidden').attr('aria-hidden', 'true').attr('tabindex', '-1');

            if (iframeElement) {
                setTimeout(function() {
                    iframeElement.css('visibility', 'hidden').attr('aria-hidden', 'true').attr('title', '');
                }, 8000);
            }

            // find all focusable elements in header
            var focusableElements = $('header').find('a, button, input, select, textarea').filter(':visible');
            var firstFocusableElement = focusableElements.first();
            var lastFocusableElement = focusableElements.last();

            // focus the first element when the menu opens
            firstFocusableElement.focus();

            lastFocusableElement.on('keydown', function (e) {
                if (e.keyCode === 9 && !e.shiftKey) { // tab key and not holding shift
                    e.preventDefault();
                    // cycle focus back to first focusable element
                    firstFocusableElement.focus();
                }
            });

            firstFocusableElement.on('keydown', function (e) {
                if (e.keyCode === 9 && e.shiftKey) { // tab key and holding shift
                    e.preventDefault();
                    // cycle focus back to last focusable element
                    lastFocusableElement.focus();
                }
            });
        } else {
            menuContainer.removeAttribute('role');
            
            $(this).attr('aria-expanded', 'false');
            $(this).attr('aria-label', 'open menu');
            $('.mobilemenuhidden').attr('aria-hidden', 'false');
            $('section').attr('aria-hidden', 'false');
            $('.triangle-inverted').attr('aria-hidden', 'false');
            $('#sitesearchform').attr('aria-hidden', 'false');
            $(childElements).css('visibility', 'visible').removeAttr('tabindex aria-hidden');

            if (iframeElement) {
                setTimeout(function() {
                    iframeElement.css('visibility', 'visible').removeAttr('tabindex aria-hidden title');
                }, 1000);
            }

            // remove keydown event handlers
            var focusableElements = $('header').find('a, button, input, select, textarea').filter(':visible');
            var firstFocusableElement = focusableElements.first();
            var lastFocusableElement = focusableElements.last();
            firstFocusableElement.off('keydown');
            lastFocusableElement.off('keydown');

            $('#menutoggle').focus();
        }
    });


    var movingBar = new MovingBar('nav');
    var initWidth = 0;
    var initLeft = 0;
    for( var i=0, max=$btnMenu11.length; i<max; i++ ){
      if($btnMenu11[i].classList.contains("on")){
       initWidth = $btnMenu11[i].offsetWidth;
       initLeft = $btnMenu11[i].offsetLeft;
       //console.log($btnMenu11[i]);
       barMovingCurrentMenu(initWidth, initLeft);
      } else {
       // initWidth = 0;
       // initLeft = 50%;
       // barMovingCurrentMenu(initWidth, initLeft);
      }


    }
});
